export const BOOKING_STATUSES = [
    'PENDING',
    'AWAITING_PAYMENT',
    'CONFIRMED',
    'ACTIVE',
    'COMPLETED',
    'CANCELLED',
];
export const PAYMENT_STATUSES = [
    'UNPAID',
    'AUTHORIZED',
    'PAID',
    'PARTIALLY_REFUNDED',
    'REFUNDED',
    'FAILED',
];
// ── The handover, and the return check ───────────────────────
//
// What the owner records when the keys change hands, in both directions.
// One record per (booking, direction): re-recording a pick-up is a
// correction, not a second handover, and the API refuses it once the
// booking has moved past the status that handover belongs to.
export const FUEL_LEVELS = ['EMPTY', 'QUARTER', 'HALF', 'THREE_QUARTERS', 'FULL'];
export const HANDOVER_KINDS = ['PICKUP', 'RETURN'];
export const HANDOVER_PHOTO_KINDS = [
    'FRONT_THREE_QUARTER',
    'REAR_THREE_QUARTER',
    'INTERIOR',
    'DASHBOARD',
];
/** How many items one car can carry on its handover list. */
export const HANDOVER_ITEMS_MAX = 20;
/** Long enough for "Child seat (0–4 yrs, Isofix)", short enough for a row. */
export const HANDOVER_ITEM_MAX_LENGTH = 60;
/**
 * The items that went out at the pick-up and did not come back.
 *
 * Matched by label, case and surrounding space aside. Empty when either
 * end is missing — nothing can be missing from a return that has not
 * happened.
 */
export function missingHandoverItems(pickup, dropoff) {
    if (!pickup || !dropoff)
        return [];
    const back = new Set(dropoff.items.filter((item) => item.present).map((item) => handoverItemKey(item.label)));
    return pickup.items
        .filter((item) => item.present && !back.has(handoverItemKey(item.label)))
        .map((item) => item.label);
}
/** What two labels are compared on: "2 Keys " and "2 keys" are one item. */
export function handoverItemKey(label) {
    return label.trim().toLocaleLowerCase();
}
